import React, { useContext } from 'react';
import c from 'classnames';
import { ActionBarDialogContext } from '../../../ActionBarContext';
import PopoverWithTooltip, {
  TooltipProps as PopoverWithTooltipProps,
} from '../../../../Popover/Preset/PopoverWithTooltip';
import s from './ActionBarItemWrapper.scss';

export type Props = {
  allowMobilePopover?: boolean;
  className?: string;
  popoverWrapperClassName?: string;
  /** Force showing the tooltip regardless of hover/click */
  forceVisibleTooltip?: boolean;
  children?: React.ReactNode | undefined;
} & Pick<
  PopoverWithTooltipProps,
  | 'renderPopover'
  | 'placement'
  | 'tooltip'
  | 'notificationTypes'
  | 'renderReference'
  | 'biData'
  | 'openBiData'
  | 'closeBiData'
>;

/**
 * Wraps any item we're going to place on the ActionBar. It provides a popover tooltip.
 *
 * e.g.
 * ```
 * <ActionBarItemWrapper tooltip="Hello World">
 *   <ActionBarButton href="...">
 *     <Icon />
 *   </ActionBarButton>
 * </ActionBarItemWrapper>
 * ```
 */
const ActionBarItemWrapper: React.FC<Props> = ({
  allowMobilePopover,
  className,
  popoverWrapperClassName,
  forceVisibleTooltip,
  ...rest
}) => {
  const isAnyDialogOpen = useContext(ActionBarDialogContext);

  return (
    <PopoverWithTooltip
      allowMobile={allowMobilePopover}
      isDisabled={isAnyDialogOpen}
      contentClassName={s['popover']}
      wrapperClassName={c(s['root-wrapper'], className)}
      referenceClassName={c(s['popover-wrapper'], popoverWrapperClassName)}
      forceVisibleTooltip={forceVisibleTooltip}
      {...rest}
    />
  );
};
ActionBarItemWrapper.displayName = 'ActionBarItemWrapper';

export default ActionBarItemWrapper;
